import React, { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Share from "./Share";
import CompanyUser from "./CompanyUser";
import ShareCompany from "./ShareCompany";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Network from "./Requests";
import CalculationInfo from "./CalculationInfo";
import { useSelector, useDispatch } from "react-redux";
import { openShare } from "../store/reducers/shareSlice";
import { deleteItem, setCurrent } from "../store/reducers/variantSlice";
import {
  setOpenPublicForm,
  setOpenPublicFormNew,
  setCopyTemplate,
  setCloseActionPanel,
} from "../store/reducers/saveGuids";
import { globalConfig } from "../configuration/config";
import axios from "axios";
import InfoModalButton from "./InfoModalButton";
import OpenParentChatButton from "./OpenParentChatButton";
import ElementLink from "./ElementLink";
import { openPublicLinkForm as openPublicLinkFormAction } from "../store/reducers/publicLinkSlice";
import { linkActive } from "../store/reducers/linkSlice";
import { useTranslation } from "react-i18next";
import VariantOptimizationModal from "./VariantOptimizationModal";
import { hasVariantOptimizationAccessToken } from "./variant-optimization";
import CalculationRenderModal from "./CalculationRenderModal";
import { VariantTreeDialog } from "./variant-tree-dialog";

const options = ["Поделиться"];

const ITEM_HEIGHT = 48;

export default function ActionProject(props) {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [variantOptimizationModalOpen, setVariantOptimizationModalOpen] =
    React.useState(false);
  const [calculationRenderModalOpen, setCalculationRenderModalOpen] =
    React.useState(false);
  const [variantTreeOpen, setVariantTreeOpen] = React.useState(false);

  const current = useSelector((state) => state.variant.current);
  const openPublickForm = useSelector(
    (state) => state.guids.openPublicLinkForm
  );
  const openPublickFormNew = useSelector(
    (state) => state.guids.openPublickFormNew
  );
  const actionPanel = useSelector((state) => state.guids.closeActionPanel);
  const companyId = useSelector((state) => state.project.companyId);
  const companyIdVariant = useSelector(
    (state) => state.variant.current?.idCompany
  );
  const dispatch = useDispatch();
  const isVariantOptimizationVisible =
    hasVariantOptimizationAccessToken() &&
    Boolean(current?.projectGuid) &&
    Boolean(current?.calculationGuid);
  const isCalculationRenderVisible = Boolean(current?.calculationGuid);

  const refreshCalculationViews = async () => {
    const calculationViews = await new Network().GetCalculationViews(
      current?.calculationGuid
    );

    if (calculationViews) {
      dispatch(
        setCurrent({
          ...current,
          ...calculationViews,
        })
      );
    }
  };

  if (typeof window.clickThreeD !== "function") {
    window.clickThreeD = (calculation, project, e) => {
      e.preventDefault();
      dispatch(linkActive(true));
      return false;
    };
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openModal, setOpen] = React.useState(false);
  const [openModalBazis, setOpenBazis] = React.useState(false);

  const handleClickOpen = () => {
    dispatch(openShare());
  };
  const exportBazis = async () => {
    try {
      const response = await axios.post(
        `${globalConfig.config.common.api}Projects/ConvertToBazis`,
        {
          projectGuid: current?.projectGuid,
          calculationGuid: current?.calculationGuid,
        },
        {
          withCredentials: true,
        }
      );
      setOpenBazis(false);
    } catch (error) {
      console.log(error);
      setOpenBazis(false);
    }
  };
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [openModalUser, setOpenUser] = React.useState(false);

  const handleClickOpenUser = () => {
    setOpenUser(true);
  };

  const [openModalFirm, setOpenFirm] = React.useState(false);

  const handleClickOpenFirm = () => {
    setOpenFirm(true);
  };

  const [openModalInfo, setOpenInfo] = React.useState(false);

  const handleClickOpenInfo = () => {
    setOpenInfo(true);
  };

  const handleCloseModalInfo = () => {
    setOpenInfo(false);
  };

  const handleCloseModalBazis = () => {
    setOpenBazis(true);
  };

  const [openModalDelete, setModalDelete] = React.useState(false);
  const [openModalDeleteVariant, setModalDeleteVariant] = React.useState(false);

  const handleClickModalDelete = () => {
    setModalDelete(true);
  };

  const handleClickModalDeleteVariant = () => {
    setModalDeleteVariant(true);
  };

  const handleCloseModalDelete = () => {
    setModalDelete(false);
  };

  const handleCloseModalDeleteVariant = () => {
    setModalDeleteVariant(false);
  };

  const handleDetele = () => {
    if (props?.current?.forDisplayTape == false) {
      new Network().DeleteProject(props.current.projectGuid);
      props.onDeleteProject(props.current.projectGuid);
      setModalDelete(false);
    }
  };

  const handleDeteleVariant = () => {
    dispatch(deleteItem(current));
    handleCloseModalDeleteVariant();
  };

  const handleCloseModalUser = () => {
    setOpenUser(false);
  };

  const handleCloseModalFirm = () => {
    setOpenFirm(false);
  };

  const openPublicLinkForm = () => {
    dispatch(setOpenPublicForm(!openPublickForm));
  };

  const copyTemplate = () => {
    dispatch(setCopyTemplate(true));
  };

  useEffect(() => {
    if (actionPanel) {
      setAnchorEl(null);
      dispatch(setCloseActionPanel(false));
    }
  }, [actionPanel]);

  return (
    <div className="project-context-menu">
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 5.5,
            minWidth: "24ch",
            minHeight: "300px",
          },
        }}
      >
        <div>
          <InfoModalButton projectGuid={current?.projectGuid} />
          <ElementLink />
          <Button
            className="bm-item menu-item"
            id="other-3d-entries"/* Не убирать этот id, он используется в приложении*/
            onClick={(e) =>
              window.clickThreeD(
                current?.calculationGuid,
                current?.projectGuid,
                e
              )
            }
          >
            {t("actionProject.other3dEntries")}
          </Button>
          {/* <Button className="bm-item menu-item" onClick={openPublicLinkForm}>
            Общественная ссылка
          </Button> */}
          <Button
            className="bm-item menu-item"
            onClick={() =>
              dispatch(
                openPublicLinkFormAction({
                  ...current,
                  guidCalculation: current?.calculationGuid,
                  guidProject: current?.projectGuid,
                })
              )
            }
          >
            {t("actionProject.publicLink")}
          </Button>

          <Button className="bm-item menu-item" onClick={copyTemplate}>
            {t("actionProject.copyTemplate")}
          </Button>

          {props.current?.forDisplayTape === false && props.current?.projectGuid && (
            <Button
              className="bm-item menu-item"
              onClick={() => {
                handleClose();
                setVariantTreeOpen(true);
              }}
            >
              {t("variantTree.title")}
            </Button>
          )}

          {isVariantOptimizationVisible && (
            <Button
              className="bm-item menu-item"
              onClick={() => {
                handleClose();
                setVariantOptimizationModalOpen(true);
              }}
            >
              {t("actionProject.optimizeVariant")}
            </Button>
          )}

          {isCalculationRenderVisible && (
            <Button
              className="bm-item menu-item"
              onClick={() => {
                handleClose();
                setCalculationRenderModalOpen(true);
              }}
            >
              {t("actionProject.regenerateImages")}
            </Button>
          )}

          {props.current.forDisplayTape == false && (
            <Button className="bm-item menu-item" onClick={handleClickOpen}>
              {t("actionProject.inviteClient")}
            </Button>
          )}

          <Button
            className="bm-item menu-item"
            onClick={() => {
              setOpenBazis(true);
            }}
          >
            {t("actionProject.exportToBazis")}
          </Button>

          {/* <OpenParentChatButton parentChatGuid={parentChatGuid} userCompanies={userCompanies} /> */}
          <OpenParentChatButton
            parentChatGuid={props?.current?.sourceProjectGuid}
            userCompanies={props?.company}
          />
          <Dialog open={openModal} keepMounted onClose={handleCloseModal}>
            <DialogContent>
              <Share
                close={handleCloseModal}
                companyId={props.companyId}
                variantGuid={props.variantGuid}
                guid={props.current.projectGuid}
                chats={props.current.chats}
              />
            </DialogContent>
          </Dialog>
          {companyId > 0 && props.current.forDisplayTape == false && (
            <>
              <Button
                className="bm-item menu-item"
                onClick={handleClickOpenUser}
              >
                {t("actionProject.addUser")}
              </Button>
              <Dialog
                sx={{ minHeight: "400px" }}
                open={openModalUser}
                keepMounted
                onClose={handleCloseModalUser}
              >
                <DialogContent>
                  <CompanyUser
                    currentCompanyId={props.companyId}
                    projectGuid={props.current.projectGuid}
                    companyId={props.companyId}
                    companyName={props.companyName}
                    close={handleCloseModalUser}
                    users={props?.current?.users}
                    chats={props?.current?.chats}
                    closePopup={handleCloseModalUser}
                  />
                </DialogContent>
              </Dialog>
            </>
          )}
          {props.current.forDisplayTape == false && (
            <>
              <Button
                className="bm-item menu-item"
                onClick={handleClickOpenInfo}
              >
                {t("actionProject.calcInfo")}
              </Button>
              <Button
                className="bm-item menu-item"
                onClick={handleClickOpenFirm}
              >
                {t("actionProject.shareWithCompany")}
              </Button>
              <a
                className="bm-item menu-item"
                href={`${globalConfig.config.common.editor}/?calculation=${current.calculationGuid}&room=${current.calculationGuid}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  padding: "6px 16px",
                  textDecoration: "none",
                  color: "inherit",
                  textAlign: "left",
                }}
              >
                {t("actionProject.modifier")}
              </a>
              <Button
                className="bm-item menu-item"
                onClick={handleClickModalDeleteVariant}
              >
                {t("actionProject.deleteVariant")}
              </Button>
              <Button
                className="bm-item menu-item"
                onClick={handleClickModalDelete}
              >
                {t("actionProject.deleteProject")}
              </Button>
            </>
          )}

          <Dialog
            open={openModalInfo}
            keepMounted
            onClose={handleCloseModalInfo}
          >
            <DialogContent>
              <CalculationInfo variant={props.variantGuid} />
            </DialogContent>
          </Dialog>

          <Dialog
            open={openModalBazis}
            keepMounted
            onClose={handleCloseModalBazis}
          >
            <DialogContent>
              <div className="infoList--title">
                {" "}
                {t("actionProject.exportToBazis")}{" "}
              </div>
              <DialogContentText id="alert-dialog-description">
                {t("actionProject.variantWillBeConverted")}{" "}
                <img src={current?.mainIconPath} style={{ width: "50px" }} />{" "}
                {t("actionProject.convertedFileWillAppear")}{" "}
                {t("actionProject.confirmExportBazis")}
              </DialogContentText>
              <div class="buttons-menu center">
                <button onClick={() => exportBazis()}>{t("yes")}</button>
                <button onClick={() => setOpenBazis(false)}>{t("no")}</button>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={openModalFirm}
            keepMounted
            onClose={handleCloseModalFirm}
          >
            <DialogContent>
              <ShareCompany
                variantGuid={props.variantGuid}
                close={handleCloseModalFirm}
              />
            </DialogContent>
          </Dialog>

          {companyId == companyIdVariant &&
            props.current.isBaseProject == false &&
            props.current.forDisplayTape == true && (
              <>
                <Button
                  className="bm-item menu-item"
                  onClick={() => props.changeBaseProject(true)}
                >
                  {t("actionProject.disableEditing")}
                </Button>
                <a
                  className="bm-item menu-item"
                  href={`${globalConfig.config.common.editor}/?calculation=${current.calculationGuid}&room=${current.calculationGuid}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    padding: "6px 16px",
                    textDecoration: "none",
                    color: "inherit",
                    textAlign: "left",
                  }}
                >
                  {t("actionProject.modifier")}
                </a>
              </>
            )}
          {companyId == companyIdVariant &&
            props.current.isBaseProject == true &&
            props.current.forDisplayTape == true && (
              <>
                <Button
                  className="bm-item menu-item"
                  onClick={() => props.changeBaseProject(false)}
                >
                  {t("actionProject.enableEditing")}
                </Button>
                <a
                  className="bm-item menu-item"
                  href={`${globalConfig.config.common.editor}/?calculation=${current.calculationGuid}&room=${current.calculationGuid}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    padding: "6px 16px",
                    textDecoration: "none",
                    color: "inherit",
                    textAlign: "left",
                  }}
                >
                  {t("actionProject.modifier")}
                </a>
              </>
            )}
          <Dialog
            open={openModalDelete}
            keepMounted
            onClose={handleCloseModalDelete}
          >
            <DialogContent>
              <div className="infoList--title">
                {t("actionProject.deleteProject")}
              </div>
              <DialogContentText id="alert-dialog-description">
                {t("dialogContent.deleteProject")}
              </DialogContentText>
              <div class="buttons-menu center">
                <button onClick={() => handleDetele()}>{t("yes")}</button>
                <button onClick={handleCloseModalDelete}>{t("no")}</button>
              </div>
            </DialogContent>
          </Dialog>
          <Dialog
            open={openModalDeleteVariant}
            keepMounted
            onClose={handleCloseModalDeleteVariant}
          >
            <DialogContent>
              <div className="infoList--title">
                {t("actionProject.deleteVariant")}
              </div>
              <DialogContentText id="alert-dialog-description">
                {t("dialogContent.deleteVariant")}
              </DialogContentText>
              <div class="buttons-menu center">
                <button onClick={() => handleDeteleVariant()}>
                  {t("yes")}
                </button>
                <button onClick={handleCloseModalDeleteVariant}>
                  {t("no")}
                </button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </Menu>
      <VariantTreeDialog
        onClose={() => setVariantTreeOpen(false)}
        open={variantTreeOpen && props.current?.forDisplayTape === false}
        projectGuid={props.current?.projectGuid}
      />
      <VariantOptimizationModal
        onClose={() => setVariantOptimizationModalOpen(false)}
        open={variantOptimizationModalOpen}
        projectGuid={current?.projectGuid}
        sourceCalculationGuid={current?.calculationGuid}
        sourceName={current?.calculationName}
      />
      <CalculationRenderModal
        calculationGuid={current?.calculationGuid}
        onClose={() => setCalculationRenderModalOpen(false)}
        onTerminal={refreshCalculationViews}
        open={calculationRenderModalOpen}
      />
    </div>
  );
}
